export default __webpack_public_path__ + "static/media/aritmofobija-guide.13f62f63.mp4";